import { render, staticRenderFns } from "./untreated.vue?vue&type=template&id=61895458&scoped=true&"
import script from "./untreated.vue?vue&type=script&lang=js&"
export * from "./untreated.vue?vue&type=script&lang=js&"
import style0 from "./untreated.vue?vue&type=style&index=0&id=61895458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61895458",
  null
  
)

export default component.exports